import React from "react";

const RewardsList = ({ data }) => (
	<div id="redeem">
		{data?.title && <h2 className="text-center py-10">{data.title}</h2>}
		<div data-lion-rewards-list></div>
	</div>
);

export default RewardsList;